import Character from "./Character/Character"
import Dialogs from "./Dialogs/Dialogs"

var that = null

class Speech {

    characters = []
    engineInitCb = null
    dialogs = null

    constructor() {
        that = this;

        this.dialogs = new Dialogs()
        this.gameData = null
    }

    getCharacter(name) {
        if(!name) return null
        return this.characters.find(chara => chara.name == name)
    }

    waitEngineInit() {
        return new Promise(function(resolve, reject) {
            that.engineInitCb = resolve
            that.loopWaitEngineInit()
        })
    }

    loopWaitEngineInit() {
        if (window.characterengineInit) that.engineInitCb()
        else setTimeout(that.loopWaitEngineInit, 200)
    }

    init(characters, gameData) {
        this.updateGameData(gameData)
        return this.createCharacters(characters)
    }

    updateGameData(gameData) {
        this.gameData = gameData
    }

    createCharacters(characters) {
        let promises = []
        characters.list.forEach(char => {
            if(char.name && !that.characters[char.name]) {
                let character = new Character(char)
                that.characters.push(character)
                promises.push(character.loadNeutral())
            }
        })
        return Promise.all(promises)
    }

    // NOTE(g) à utiliser pour charger le fichier
    addDialogs(dialogsFile) {
        this.dialogs.addDialogs(dialogsFile, this.gameData)
    }

    loadAllDialogs(characters) {
        let promises = []
        let attitudes = this.dialogs.getAllAttitudes()

        promises.push(this.dialogs.loadAllDials())

        characters.forEach(chara => {
            let prom = chara.loadAttitudes(attitudes).then(() => chara.loadAnimRequiredFiles())
            promises.push(prom)
        })

        return Promise.all(promises)
    }

    loadDialogs(characters, ids) {
        let promises = []
        let attitudes = this.dialogs.getAttitudes(ids)
        promises.push(this.dialogs.loadDials(ids))
        characters.forEach(chara => {
            let prom = chara.loadAttitudes(attitudes).then(() => chara.loadAnimRequiredFiles())

            promises.push(prom)
        })

        return Promise.all(promises)
    }

    startCharacterAnim(name) {
        this.getCharacter(name).start()
    }

    playDialog(character, dialId, cb) {
        this.dialogs.stop()
        this.dialogs.clearDialQueue()
        this.dialogs.addDialToQueue(dialId, cb, character)
    }

    queueDialog(character, dialId, cb) {
        this.dialogs.addDialToQueue(dialId, cb, character)
    }
}

export default new Speech()